<div class="container pt-4">
  <div class="d-flex justify-content-center renewal-container">
    <h5 class="text-center mb-3 text-white">{{ url$?.title }}</h5>
    <a class="d-flex justify-content-center" href="{{ url$?.statement_url }}">
      <button [hidden]="showButton" class="btn btn-primary rounded-4 text-white fw-bold">
        {{ 'my.renewals.button' | translate }}
      </button>
    </a>
  </div>
</div>
